const STORAGE_KEY = 'editions-vibes-starred'

export const getStarredSessions = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : []
  } catch (error) {
    console.warn('Failed to load starred sessions:', error)
    return []
  }
}

export const saveStarredSessions = (starred) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(starred))
  } catch (error) {
    console.warn('Failed to save starred sessions:', error)
  }
} 